var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFamilyHomePurple = function SvgFamilyHomePurple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#family-home-purple_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "family-home-purple_svg__b",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M20 0H0v20h20z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#family-home-purple_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#family-home-purple_svg__c)",
    d: "M9.933 15.163a.96.96 0 0 0 .647-.24q.766-.694 1.461-1.365a14 14 0 0 0 1.21-1.318q.515-.646.827-1.258.31-.61.311-1.186 0-1.054-.719-1.749a2.4 2.4 0 0 0-1.725-.694q-.622 0-1.138.251a2.8 2.8 0 0 0-.874.659 2.7 2.7 0 0 0-.899-.659 2.6 2.6 0 0 0-1.114-.251q-1.006 0-1.725.694t-.719 1.75q0 .575.312 1.185.312.612.827 1.258t1.21 1.318q.695.67 1.46 1.365.145.12.3.18.156.06.348.06m-5.75 3.21q-.791 0-1.354-.563a1.85 1.85 0 0 1-.563-1.353V9.389l-.958.743a1 1 0 0 1-.719.191.88.88 0 0 1-.623-.383.95.95 0 0 1-.18-.719.94.94 0 0 1 .372-.623l8.6-6.588a1.98 1.98 0 0 1 1.175-.384 2 2 0 0 1 1.174.384l8.625 6.588a.9.9 0 0 1 .36.623 1 1 0 0 1-.193.719.9.9 0 0 1-.623.36.91.91 0 0 1-.694-.192l-.983-.719v7.068q0 .79-.563 1.353a1.85 1.85 0 0 1-1.353.563zm0-1.916h11.5v-8.53l-5.75-4.384-5.75 4.385z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "family-home-purple_svg__c",
    x1: -0.226,
    x2: 20.099,
    y1: 10,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#580EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6701A9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "family-home-purple_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgFamilyHomePurple;